import { sortOptionsConfig } from '@atlassian/mpac-primitives';
import { useEffect, useRef, useState } from 'react';
import { getSortFilter } from '../../utils/UrlMapUtils';
import { useSort } from '../useSort';
export const useSortFilter = () => {
  const [selectedMobileSortOption, setSelectedMobileSortOption] = useState(sortOptionsConfig[0]);
  const {
    selectedSortKey: commitSortKey,
    onSortOptionSelect: onCommitSortOptionSelect,
    setSelectedSortKey: setCommitSortKey
  } = useSort();

  // set selected sort option when it is loaded from URL params
  // only need to run twice for initial load (first initial render = "", second render selectedSortKey is populated from URL params)
  const runCount = useRef(0);
  useEffect(() => {
    if (commitSortKey && runCount.current < 1) {
      setSelectedMobileSortOption(getSortFilter(commitSortKey) || selectedMobileSortOption);
      runCount.current++;
    }
  }, [commitSortKey, selectedMobileSortOption]);
  return {
    commitSortKey,
    setCommitSortKey,
    onCommitSortOptionSelect,
    selectedMobileSortOption,
    setSelectedMobileSortOption
  };
};